module.exports = __webpack_public_path__ + "img/about_icon_nfts@2x.4caee969.png";